import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'ap-hint-dialog',
  templateUrl: './hint-dialog.component.html',
  host: {
    'class': 'ap-step',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HintDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}
